import { TranslatePipe } from '../../shared/translate/pipes/translate.pipe';
import { DetailsChangesView } from '../models/details.changes.model';
import { IAuditEvent } from '@ahryman40k/ts-fhir-types/lib/R4';

const OPERATION_NAMES = {
    Count: 'COUNT',
    Avg: 'AVERAGE',
    Std: 'SCATTER',
};

function translateUnit(unit: string, translatePipe: TranslatePipe): string {
    return translatePipe.transform(unit.toUpperCase()) === unit.toUpperCase() ?
        unit : translatePipe.transform(unit.toUpperCase());
}

export function stringToDetailChanges(inData: IAuditEvent[], translatePipe: TranslatePipe): DetailsChangesView[] {
    const detailsChangesViews: DetailsChangesView[] = [];

    if (inData && inData[0]) {
        inData.map(data => {
            const oldSplit = data.entity[0].detail[0].valueString.split(';');
            const newSplit = data.entity[0].detail[1].valueString.split(';');

            let values: string[];
            if (newSplit[0] === 'atomic') {
                values = [
                    translatePipe.transform(newSplit[1].toUpperCase()), oldSplit.length > 1 ?
                        oldSplit[2] + ' ' + translateUnit(oldSplit[3], translatePipe) +
                        (oldSplit[4] ? ' - ' + oldSplit[4] + ' ' + translateUnit(oldSplit[5], translatePipe) : '') : null,
                    newSplit[2] + ' ' + translateUnit(newSplit[3], translatePipe) +
                    (newSplit[4] ? ' - ' + newSplit[4] + ' ' + translateUnit(newSplit[5], translatePipe) : '')
                ];
            } else if (newSplit[0] === 'aggregated') {
                values = [
                    translatePipe.transform(newSplit[1].toUpperCase()), oldSplit.length > 1 ?
                        oldSplit[2] + ' ' + translatePipe.transform(oldSplit[3].toUpperCase()) + ' - ' +
                        translatePipe.transform(OPERATION_NAMES[oldSplit[4]]) + ' - ' + oldSplit[5] + ' ' + oldSplit[6] : null,
                    newSplit[2] + ' ' + translatePipe.transform(newSplit[3].toUpperCase()) + ' - ' +
                    translatePipe.transform(OPERATION_NAMES[newSplit[4]]) + ' - ' + newSplit[5] + ' ' + newSplit[6]
                ];
            } else if (newSplit[0] === 'goal') {
                values = [
                    translatePipe.transform(newSplit[1].toUpperCase()),
                    oldSplit.length > 1 ? oldSplit[2] + ' ' + translateUnit(oldSplit[3], translatePipe) : null,
                    newSplit[2] + ' ' + translateUnit(newSplit[3], translatePipe)
                ];
            }
            detailsChangesViews.unshift({
                values,
                comment: {
                    authorReference: {
                        display: data.source.observer.display,
                    },
                    text: data.entity[0].description,
                    time: new Date(data.recorded)
                }
            });
        });
    }
    return detailsChangesViews;
}
